import React from 'react';

import './Spinner.css';
import Auxiliary from '../../hoc/Auxiliary/Auxiliary';
import Backdrop from '../Backdrop/Backdrop';

const spinner = (props) => {
    let progress = {
        width: '75%'
    };
    if (props.progress <= 0)
        progress.width = '0%';
    else if (props.progress >= 100)
        progress.width = '100%';
    else
        progress.width = props.progress + '%';
    
    return (
        <Auxiliary>
            <Backdrop show />
            {/*<div className="Loader">Loading...</div>*/}
            <div className="ProgressBorder">
                <div className="ProgressBar" style={progress}></div>
            </div>
        </Auxiliary>
    );
};

export default spinner;